/** @format */

import $http from '../../shared/http';

export const permissions = {
  namespaced: true,
  state: () => {
    return {
      permissions: [],
      routePermissions: [],
      permissionRoles: [],
      createPermissionData: {
        name: '',
        description: '',
        roles: [],
      },
      permissionEditData: {
        permission_id: null,
        description: '',
        roles: [],
      },
      currentPermission: null,
      permissionEdited: false,
      newPermissionID: null,
      permissionsForSelect: null,
    };
  },
  getters: {
    getPermission: (state) => (permission) => state.routePermissions.includes(permission),

    canCreateUsers: (state, getters) => getters['getPermission']('can_create_users'),
    canViewUsers: (state, getters) => getters['getPermission']('can_view_users'),
    canListUsers: (state, getters) => getters['getPermission']('can_list_users'),
    canEditUsers: (state, getters) => getters['getPermission']('can_edit_users'),
    canDeleteUsers: (state, getters) => getters['getPermission']('can_delete_users'),
    canViewMembersAccounts: (state, getters) =>
      getters['getPermission']('can_view_members_accounts'),
    canEditMembersAccounts: (state, getters) =>
      getters['getPermission']('can_edit_members_accounts'),
    canDeleteMembersAccounts: (state, getters) =>
      getters['getPermission']('can_delete_members_account'),
    canCreateMembersProfiles: (state, getters) =>
      getters['getPermission']('can_create_members_profiles'),
    canViewMembersProfiles: (state, getters) =>
      getters['getPermission']('can_view_members_profiles'),
    canEditMembersProfiles: (state, getters) =>
      getters['getPermission']('can_edit_members_profiles'),
    canListMembersProfiles: (state, getters) =>
      getters['getPermission']('can_list_members_profiles'),
    canApproveContactDetailsAccesses: (state, getters) =>
      getters['getPermission']('can_approve_contact_details_accesses'),
    canViewRoles: (state, getters) => getters['getPermission']('can_view_roles'),
    canCreateRoles: (state, getters) => getters['getPermission']('can_create_roles'),
    canEditRoles: (state, getters) => getters['getPermission']('can_edit_roles'),
    canDeleteRoles: (state, getters) => getters['getPermission']('can_delete_roles'),
    canCreatePermissions: (state, getters) => getters['getPermission']('can_create_permissions'),
    canViewPermissions: (state, getters) => getters['getPermission']('can_view_permissions'),
    canEditPermissions: (state, getters) => getters['getPermission']('can_edit_permissions'),
    canDeletePermissions: (state, getters) => getters['getPermission']('can_delete_permissions'),
    canEditSelf: (state, getters) => getters['getPermission']('can_edit_self'),
    canViewLogs: (state, getters) => getters['getPermission']('can_view_logs'),
    canDeleteLogs: (state, getters) => getters['getPermission']('can_delete_logs'),
    canCreateMinistries: (state, getters) => getters['getPermission']('can_create_ministries'),
    canViewMinistries: (state, getters) => getters['getPermission']('can_view_ministries'),
    canEditMinistries: (state, getters) => getters['getPermission']('can_edit_ministries'),
    canDeleteMinistries: (state, getters) => getters['getPermission']('can_delete_ministries'),
    canEditCountries: (state, getters) => getters['getPermission']('can_edit_countries'),
    canEditStates: (state, getters) => getters['getPermission']('can_edit_states'),
    canCreateCongregations: (state, getters) =>
      getters['getPermission']('can_create_congregations'),
    canViewCongregations: (state, getters) => getters['getPermission']('can_view_congregations'),
    canEditCongregations: (state, getters) => getters['getPermission']('can_edit_congregations'),
    canDeleteCongregations: (state, getters) =>
      getters['getPermission']('can_delete_congregations'),
    canCreateZones: (state, getters) => getters['getPermission']('can_create_zones'),
    canViewZones: (state, getters) => getters['getPermission']('can_view_zones'),
    canEditZones: (state, getters) => getters['getPermission']('can_edit_zones'),
    canDeleteZones: (state, getters) => getters['getPermission']('can_delete_zones'),
    canCreatePositions: (state, getters) => getters['getPermission']('can_create_positions'),
    canViewPositions: (state, getters) => getters['getPermission']('can_view_positions'),
    canEditPositions: (state, getters) => getters['getPermission']('can_edit_positions'),
    canDeletePositions: (state, getters) => getters['getPermission']('can_delete_positions'),
    canCreateStatuses: (state, getters) => getters['getPermission']('can_create_statuses'),
    canViewStatuses: (state, getters) => getters['getPermission']('can_view_statuses'),
    canEditStatuses: (state, getters) => getters['getPermission']('can_edit_statuses'),
    canDeleteStatuses: (state, getters) => getters['getPermission']('can_delete_statuses'),
    canViewSystemSettings: (state, getters) => getters['getPermission']('can_view_system_settings'),
    canEditSystemSettings: (state, getters) => getters['getPermission']('can_edit_system_settings'),
    canCreateServices: (state, getters) => getters['getPermission']('can_create_services'),
    canViewServices: (state, getters) => getters['getPermission']('can_view_services'),
    canListServices: (state, getters) => getters['getPermission']('can_list_services'),
    canEditServices: (state, getters) => getters['getPermission']('can_edit_services'),
    canDeleteServices: (state, getters) => getters['getPermission']('can_delete_services'),
    canCreateAttendances: (state, getters) => getters['getPermission']('can_create_attendances'),
    canViewAttendances: (state, getters) => getters['getPermission']('can_view_attendances'),
    canEditAttendances: (state, getters) => getters['getPermission']('can_edit_attendances'),
    canDeleteAttendances: (state, getters) => getters['getPermission']('can_delete_attendances'),
    canViewOrganisationSettings: (state, getters) =>
      getters['getPermission']('can_view_organisation_settings'),
    canEditOrganisationSettings: (state, getters) =>
      getters['getPermission']('can_edit_organisation_settings'),
    canCreateServiceTypes: (state, getters) => getters['getPermission']('can_create_service_types'),
    canViewServiceTypes: (state, getters) => getters['getPermission']('can_view_service_types'),
    canEditServiceTypes: (state, getters) => getters['getPermission']('can_edit_service_types'),
    canDeleteServiceTypes: (state, getters) => getters['getPermission']('can_delete_service_types'),
    canCreateVisitors: (state, getters) => getters['getPermission']('can_create_visitors'),
    canViewVisitors: (state, getters) => getters['getPermission']('can_view_visitors'),
    canEditVisitors: (state, getters) => getters['getPermission']('can_edit_visitors'),
    canDeleteVisitors: (state, getters) => getters['getPermission']('can_delete_visitors'),
    canCreateGroups: (state, getters) => getters['getPermission']('can_create_groups'),
    canViewGroups: (state, getters) => getters['getPermission']('can_view_groups'),
    canListGroups: (state, getters) => getters['getPermission']('can_list_groups'),
    canEditGroups: (state, getters) => getters['getPermission']('can_edit_groups'),
    canDeleteGroups: (state, getters) => getters['getPermission']('can_delete_groups'),
    canCreateOrganisations: (state, getters) =>
      getters['getPermission']('can_create_organisations'),
    canViewOrganisations: (state, getters) => getters['getPermission']('can_view_organisations'),
    canEditOrganisations: (state, getters) => getters['getPermission']('can_edit_organisations'),
    canDeleteOrganisations: (state, getters) =>
      getters['getPermission']('can_delete_organisations'),
    canViewOrganisationDirectory: (state, getters) =>
      getters['getPermission']('can_view_organisation_directory'),
    canViewOrganisationBulletin: (state, getters) =>
      getters['getPermission']('can_view_organisation_bulletin'),
    canViewOrganisationDashboard: (state, getters) =>
      getters['getPermission']('can_view_organisation_dashboard'),
    canViewApplicationDashboard: (state, getters) =>
      getters['getPermission']('can_view_application_dashboard'),
    canViewDevelopmentContents: (state, getters) =>
      getters['getPermission']('can_view_development_contents'),
    canCreateServiceActivitiesTemplates: (state, getters) =>
      getters['getPermission']('can_create_service_activities_templates'),
    canViewServiceActivitiesTemplates: (state, getters) =>
      getters['getPermission']('can_view_service_activities_templates'),
    canEditServiceActivitiesTemplates: (state, getters) =>
      getters['getPermission']('can_edit_service_activities_templates'),
    canDeleteServiceActivitiesTemplates: (state, getters) =>
      getters['getPermission']('can_delete_service_activities_templates'),
    canCreateDownloadableFiles: (state, getters) =>
      getters['getPermission']('can_create_downloadable_files'),
    canViewDownloadableFiles: (state, getters) =>
      getters['getPermission']('can_view_downloadable_files'),
    canEditDownloadableFiles: (state, getters) =>
      getters['getPermission']('can_edit_downloadable_files'),
    canDeleteDownloadableFiles: (state, getters) =>
      getters['getPermission']('can_delete_downloadable_files'),
    canCreateOrganisationGroups: (state, getters) =>
      getters['getPermission']('can_create_organisation_groups'),
    canViewOrganisationGroups: (state, getters) =>
      getters['getPermission']('can_view_organisation_groups'),
    canListOrganisationGroups: (state, getters) =>
      getters['getPermission']('can_list_organisation_groups'),
    canEditOrganisationGroups: (state, getters) =>
      getters['getPermission']('can_edit_organisation_groups'),
    canDeleteOrganisationGroups: (state, getters) =>
      getters['getPermission']('can_delete_organisation_groups'),
    canCreateSmsSettings: (state, getters) => getters['getPermission']('can_create_sms_settings'),
    canViewSmsSettings: (state, getters) => getters['getPermission']('can_view_sms_settings'),
    canEditSmsSettings: (state, getters) => getters['getPermission']('can_edit_sms_settings'),
    canDeleteSmsSettings: (state, getters) => getters['getPermission']('can_delete_sms_settings'),
    canSendSms: (state, getters) => getters['getPermission']('can_send_sms'),
    canMakePayments: (state, getters) => getters['getPermission']('can_make_payments'),
    canReadPayments: (state, getters) => getters['getPermission']('can_read_payments'),
    canEditPayments: (state, getters) => getters['getPermission']('can_edit_payments'),
    canDeletePayments: (state, getters) => getters['getPermission']('can_delete_payments'),
    canDownloadOrPrintReports: (state, getters) =>
      getters['getPermission']('can_print_or_download_reports'),
    canListVisitors: (state, getters) => getters['getPermission']('can_list_visitors'),
    canListServiceActivitiesTemplates: (state, getters) =>
      getters['getPermission']('can_list_service_activities_templates'),
    canListOrganisations: (state, getters) => getters['getPermission']('can_list_organisations'),
    canListStatuses: (state, getters) => getters['getPermission']('can_list_statuses'),
    canListDownloadableFiles: (state, getters) =>
      getters['getPermission']('can_list_downloadable_files'),
    canListServiceTypes: (state, getters) => getters['getPermission']('can_list_service_types'),
    canListCongregations: (state, getters) => getters['getPermission']('can_list_congregations'),
    canListPositions: (state, getters) => getters['getPermission']('can_list_positions'),
    canListRoles: (state, getters) => getters['getPermission']('can_list_roles'),
    canListPermissions: (state, getters) => getters['getPermission']('can_list_permissions'),
    canListZones: (state, getters) => getters['getPermission']('can_list_zones'),
    canListMinistries: (state, getters) => getters['getPermission']('can_list_ministries'),
    canListMembersAccounts: (state, getters) =>
      getters['getPermission']('can_list_members_accounts'),
    canCreateFollowUps: (state, getters) => getters['getPermission']('can_create_follow_ups'),
    canViewFollowUps: (state, getters) => getters['getPermission']('can_view_follow_ups'),
    canListFollowUps: (state, getters) => getters['getPermission']('can_list_follow_ups'),
    canEditFollowUps: (state, getters) => getters['getPermission']('can_edit_follow_ups'),
    canDeleteFollowUps: (state, getters) => getters['getPermission']('can_delete_follow_ups'),
    canListFinancialBudgets: (state, getters) =>
      getters['getPermission']('can_list_financial_budgets'),
    canViewFinancialBudgets: (state, getters) =>
      getters['getPermission']('can_view_financial_budgets'),
    canCreateFinancialBudgets: (state, getters) =>
      getters['getPermission']('can_create_financial_budgets'),
    canEditFinancialBudgets: (state, getters) =>
      getters['getPermission']('can_edit_financial_budgets'),
    canApproveFinancialBudgets: (state, getters) =>
      getters['getPermission']('can_approve_financial_budgets'),
    canDeleteFinancialBudgets: (state, getters) =>
      getters['getPermission']('can_delete_financial_budgets'),
    canListFinancialRequests: (state, getters) =>
      getters['getPermission']('can_list_financial_requests'),
    canViewFinancialRequests: (state, getters) =>
      getters['getPermission']('can_view_financial_requests'),
    canCreateFinancialRequests: (state, getters) =>
      getters['getPermission']('can_create_financial_requests'),
    canEditFinancialRequests: (state, getters) =>
      getters['getPermission']('can_edit_financial_requests'),
    canApproveFinancialRequests: (state, getters) =>
      getters['getPermission']('can_approve_financial_requests'),
    canDeleteFinancialRequests: (state, getters) =>
      getters['getPermission']('can_delete_financial_requests'),
    canListDenominationLevelRequests: (state, getters) =>
      getters['getPermission']('can_list_denomination_level_requests'),
    canViewDenominationLevelRequests: (state, getters) =>
      getters['getPermission']('can_view_denomination_level_requests'),
    canApproveDenominationLevelRequests: (state, getters) =>
      getters['getPermission']('can_approve_denomination_level_requests'),
    canSendDenominationLevelRequests: (state, getters) =>
      getters['getPermission']('can_send_denomination_level_requests'),
    canDeleteDenominationLevelRequests: (state, getters) =>
      getters['getPermission']('can_delete_denomination_level_requests'),
    canListDenominationLevels: (state, getters) =>
      getters['getPermission']('can_list_denomination_levels'),
    canCreateDenominationLevels: (state, getters) =>
      getters['getPermission']('can_create_denomination_levels'),
    canEditDenominationLevels: (state, getters) =>
      getters['getPermission']('can_edit_denomination_levels'),
    canViewDenominationLevels: (state, getters) =>
      getters['getPermission']('can_view_denomination_levels'),
    canDeleteDenominationLevels: (state, getters) =>
      getters['getPermission']('can_delete_denomination_levels'),
    // no `canEditDenominationChurches` use `canEditChurches`
    canViewDenominationChurches: (state, getters) =>
      getters['getPermission']('can_view_denomination_churches'),
    canListDenominationChurches: (state, getters) =>
      getters['getPermission']('can_list_denomination_churches'),
    canCreateDenominationChurches: (state, getters) =>
      getters['getPermission']('can_create_denomination_churches'),
    canDeleteDenominationChurches: (state, getters) =>
      getters['getPermission']('can_delete_denomination_churches'),
    canCreateDenominationLevelChurches: (state, getters) =>
      getters['getPermission']('can_create_denomination_level_churches'),
    canEditDenominationLevelChurches: (state, getters) =>
      getters['getPermission']('can_edit_denomination_level_churches'),
    canViewDenominationLevelChurches: (state, getters) =>
      getters['getPermission']('can_view_denomination_level_churches'),
    canListDenominationLevelChurches: (state, getters) =>
      getters['getPermission']('can_list_denomination_level_churches'),
    canDeleteDenominationLevelChurches: (state, getters) =>
      getters['getPermission']('can_delete_denomination_level_churches'),
    canViewBranchManagementDashboard: (state, getters) =>
      getters['getPermission']('can_view_branch_management_dashboard'),
    canCreateDenominations: (state, getters) => getters['canCreateOrganisationGroups'],
    canViewDenominations: (state, getters) => getters['canViewOrganisationGroups'],
    canListDenominations: (state, getters) => getters['canListOrganisationGroups'],
    canEditDenominations: (state, getters) => getters['canEditOrganisationGroups'],
    canDeleteDenominations: (state, getters) => getters['canDeleteOrganisationGroups'],
    canCreateRosters: (state, getters) => getters['getPermission']('can_create_rosters'),
    canViewRosters: (state, getters) => getters['getPermission']('can_view_rosters'),
    canListRosters: (state, getters) => getters['getPermission']('can_list_rosters'),
    canEditRosters: (state, getters) => getters['getPermission']('can_edit_rosters'),
    canDeleteRosters: (state, getters) => getters['getPermission']('can_delete_rosters'),
    canCreateRosterTemplates: (state, getters) =>
      getters['getPermission']('can_create_roster_templates'),
    canViewRosterTemplates: (state, getters) =>
      getters['getPermission']('can_view_roster_templates'),
    canListRosterTemplates: (state, getters) =>
      getters['getPermission']('can_list_roster_templates'),
    canEditRosterTemplates: (state, getters) =>
      getters['getPermission']('can_edit_roster_templates'),
    canDeleteRosterTemplates: (state, getters) =>
      getters['getPermission']('can_delete_roster_templates'),

    canCreateFundraisings: (state, getters) => getters['getPermission']('can_create_fundraisings'),
    canViewFundraisings: (state, getters) => getters['getPermission']('can_view_fundraisings'),
    canListFundraisings: (state, getters) => getters['getPermission']('can_list_fundraisings'),
    canEditFundraisings: (state, getters) => getters['getPermission']('can_edit_fundraisings'),
    canDeleteFundraisings: (state, getters) => getters['getPermission']('can_delete_fundraisings'),

    canCreatePosts: (state, getters) => getters['getPermission']('can_create_posts'),
    // canViewPosts: (state, getters) => getters['getPermission']('can_view_posts'),
    canListPosts: (state, getters) => getters['getPermission']('can_list_posts'),
    canEditPosts: (state, getters) => getters['getPermission']('can_edit_posts'),
    canDeletePosts: (state, getters) => getters['getPermission']('can_delete_posts'),

    canListPayments: (state, getters) => getters['getPermission']('can_list_payments'),
    canCreateDocsArticles: (state, getters) => getters['getPermission']('can_create_docs_articles'),
    canViewDocsArticles: (state, getters) => getters['getPermission']('can_view_docs_articles'),
    canListDocsArticles: (state, getters) => getters['getPermission']('can_list_docs_articles'),
    canEditDocsArticles: (state, getters) => getters['getPermission']('can_edit_docs_articles'),
    canDeleteDocsArticles: (state, getters) => getters['getPermission']('can_delete_docs_articles'),
    canEditDocsTopics: (state, getters) => getters['getPermission']('can_edit_docs_topics'),

    canCreateGlobalUsers: (state, getters) => getters['getPermission']('can_create_global_users'),
    canListGlobalUsers: (state, getters) => getters['getPermission']('can_list_global_users'),
    canViewGlobalUsers: (state, getters) => getters['getPermission']('can_view_global_users'),
    canEditGlobalUsers: (state, getters) => getters['getPermission']('can_edit_global_users'),
    canDeleteGlobalUsers: (state, getters) => getters['getPermission']('can_delete_global_users'),

    canListLegalDocuments: (state, getters) => getters['getPermission']('can_list_legal_documents'),
    canViewLegalDocuments: (state, getters) => getters['getPermission']('can_view_legal_documents'),
    canEditLegalDocuments: (state, getters) => getters['getPermission']('can_edit_legal_documents'),
    canPublishLegalDocuments: (state, getters) =>
      getters['getPermission']('can_publish_legal_documents'),
    canUnpublishLegalDocuments: (state, getters) =>
      getters['getPermission']('can_unpublish_legal_documents'),

    canMergeChurchFunctions: (state, getters) =>
      getters['getPermission']('can_merge_church_functions'),
    canDeleteChurchFunctions: (state, getters) =>
      getters['getPermission']('can_delete_church_functions'),
    canEditChurchFunctions: (state, getters) =>
      getters['getPermission']('can_edit_church_functions'),

    canPerformChurchOnboarding: (state, getters) =>
      getters['getPermission']('can_perform_church_onboarding'),

    canViewChurchClaims: (state, getters) => getters['getPermission']('can_view_church_claims'),
    canListChurchClaims: (state, getters) => getters['getPermission']('can_list_church_claims'),

    canListSmsAccounts: (state, getters) => getters['getPermission']('can_list_sms_accounts'),

    canListModerationReports: (state, getters) =>
      getters['getPermission']('can_list_moderation_reports'),
    canViewModerationReports: (state, getters) =>
      getters['getPermission']('can_view_moderation_reports'),
    canListProductSubscriptionEnquiries: (state, getters) =>
      getters['getPermission']('can_list_product_subscription_enquiries'),
    canListProductSubscriptions: (state, getters) =>
      getters['getPermission']('can_list_product_subscriptions'),
    canListProductSubscriptionRefunds: (state, getters) =>
      getters['getPermission']('can_list_product_subscription_refunds'),
    canListPaymentMethods: (state, getters) => getters['getPermission']('can_list_payment_methods'),
    canListMakeSubscriptionPayments: (state, getters) =>
      getters['getPermission']('can_make_product_subscription_payments'),

    canInteractWithBranchManagement: (state, getters, rootState, rootGetters) => {
      if (rootGetters['auth/isGlobalUser']) {
        return getters['canListDenominationLevels'];
      } else {
        return (
          getters['canListDenominationLevels'] &&
          rootGetters['organisations/isBranchManagementAllowedForChurch']
        );
      }
    },

    canInteractWithBranchManagementDashboard: (state, getters, rootState, rootGetters) =>
      getters['canViewBranchManagementDashboard'] &&
      !rootGetters['auth/isGlobalUser'] &&
      rootGetters['organisations/isBranchManagementAllowedForChurch'],

    canInteractWithPendingBranchManagementRequests: (state, getters, rootState, rootGetters) => {
      if (rootGetters['auth/isGlobalUser']) {
        return getters['canListDenominationLevelRequests'];
      } else {
        return (
          getters['canListDenominationLevelRequests'] &&
          rootGetters['branch_management/IS_BRANCH_MANAGEMENT_ACCESS_FULLY_APPROVED'] &&
          rootGetters['organisations/isBranchManagementAllowedForChurch']
        );
      }
    },
    getPermissions: (state) => state.permissions,
    getPermissionsForSelect: (state) => state.permissionsForSelect,
    getCreatePermissionData: (state) => state.createPermissionData,
    getCurrentPermission: (state) => state.currentPermission,
    getPermissionEditData: (state) => state.permissionEditData,
    getPermissionCreationData: (state) => state.permissionCreationData,
    getPermissionRolesForSelect: (state) =>
      state.permissionRoles.map((permission) => {
        return permission.id;
      }),
    isPermissionEdited: (state) => state.permissionEdited,
    getNewPermissionID: (state) => state.newPermissionID,

    lazyPermissionResolver: (state, getters) => (permission) => getters[permission],
  },
  mutations: {
    setPermissions: (state, data) => (state.permissions = data),
    setCurrentPermission: (state, payload) => (state.currentPermission = payload),
    setRoutePermissions: (state, data) => (state.routePermissions = data),
    setCreatePermissionData: (state, formData) => (state.createPermissionData = formData),
    initPermissionData: (state) => {
      state.createPermissionData.name = '';
      state.createPermissionData.description = '';
      state.createPermissionData.roles = [];
    },
    setPermissionEdited: (state, bool) => {
      state.permissionEdited = bool;
    },
    setNewPermissionID: (state, id) => (state.newPermissionID = id),
    setPermissionEditData: (state, formData) => {
      state.permissionEditData.roles = formData.roles;
      state.permissionEditData.description = formData.description;
    },
    initPermissionEditData: (state) => {
      state.permissionEditData.permission_id = null;
      state.permissionEditData.roles = [];
      state.permissionEditData.description = '';
    },
    setPermissionRoles: (state, roles) => {
      state.permissionRoles = roles;
    },
    setPermissionsForSelect: (state, payload) => (state.permissionsForSelect = payload),
  },
  actions: {
    async loadRoutePermissions({ commit }, { churchId }) {
      return $http('v2')
        .get(`${churchId ? `organisations/${churchId}/` : ''}route_permissions`)
        .then((response) => {
          commit('setRoutePermissions', response.data.data);
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    async loadPermissions({ commit }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get('/permissions', {
            params: {
              no_paginate: true,
            },
          })
          .then((response) => {
            //console.log(response)
            commit('setPermissions', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            //console.log(error)
            reject(error);
          });
      });
    },
    async loadPermission({ commit }, permission_id) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/permissions/${permission_id}`)
          .then((response) => {
            //console.log(response)
            commit('setCurrentPermission', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            //console.log(error)
            reject(error);
          });
      });
    },
    // eslint-disable-next-line no-unused-vars
    async createPermission({ commit, getters }) {
      commit('setPermissionEdited', false);
      return new Promise(async (resolve, reject) => {
        await $http()
          .post('/permission', getters['getCreatePermissionData'], {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then((response) => {
            //console.log(response)
            commit('setPermissionEdited', true);
            commit('setNewPermissionID', response.data.data.id);
            return resolve(response);
          })
          .catch((error) => {
            //console.log(error)
            commit('setPermissionEdited', false);
            reject(error);
          });
      });
    },
    async loadPermissionRoles({ commit }, permission_id) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/permissions/${permission_id}/roles?no_paginate=true`)
          .then((response) => {
            commit('setPermissionRoles', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async editPermission({ commit, getters }, permission_id) {
      commit('setPermissionEdited', false);
      return new Promise(async (resolve, reject) => {
        await $http()
          .patch(`/permissions/${permission_id}`, getters['getPermissionEditData'], {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then((response) => {
            commit('setPermissionEdited', true);
            return resolve(response);
          })
          .catch((error) => {
            commit('setPermissionEdited', false);
            reject(error);
          });
      });
    },
    async loadPermissionsForSelect({ commit }) {
      return await $http('v2')
        .get('permissions/select')
        .then((response) => {
          commit('setPermissionsForSelect', response.data.data);
          return response;
        });
    },
  },
};
